import CloseIcon from '@mui/icons-material/Close'
import {
  Breakpoint,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  PaperProps,
} from '@mui/material'
import React, { FC } from 'react'

interface ComponentProps {
  isVisible?: boolean
  setIsVisible: any
  title: string
  fullWidth?: boolean
  maxWidth?: Breakpoint | false
  paperProps?: Partial<PaperProps>
}

interface DialogTitleProps {
  children?: React.ReactNode
  onClose: () => void
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}
const CloseableDialog: FC<ComponentProps> = (props) => {
  const {
    isVisible = true,
    setIsVisible,
    title,
    children,
    fullWidth = true,
    maxWidth = 'lg',
    paperProps,
  } = props

  return (
    <Dialog
      open={isVisible}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      onClose={() => setIsVisible(false)}
      PaperProps={paperProps}
    >
      <BootstrapDialogTitle onClose={() => setIsVisible(false)}>
        {title}
      </BootstrapDialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  )
}
export default CloseableDialog
